import type { Geolocation } from '~/types/geolocation'

export default () => {
    const { ssrContext } = useNuxtApp()

    return useState<Geolocation>('geolocation', () => ssrContext?.event.context.geolocation).value
}
